import { agreementsReducer } from "./agreementsReducer";
import { authReducer } from "./auth-reducer";
import { experimentReducer } from "./experimentReducer";
import { financialAgreementReducer } from "./financialAgreementReducer";
import { loadersReducer } from "./loadersReducer";
import { loanReducer } from "./loan-reducer";
import { newFormReducer } from "./newform-reducer";
import { oauthReducer } from "./oauthReducer";
import { passportReducer } from "./passport-reducer";
import { progressbarReducer } from "./progressbar-reducer";
import { registrationReducer } from "./regestration-reducer";
import { registrationDocumentsReducer } from "./registrationDocumentsReducer";
import { serverSettingsReducer } from "./serverSettingsReducer";
import { stepsReducer } from "./stepsReducer";
import { uiReducer } from "./uiReducer";
import { userExperimentsReducer } from "./userExperimentsReducer";
import { vasBlockReducer } from "./vasBlockReducer";

export const reducers = {
  loanReducer,
  registrationReducer,
  newFormReducer,
  progressbarReducer,
  authReducer,
  passportReducer,
  uiReducer,
  financialAgreementReducer,
  vasBlockReducer,
  stepsReducer,
  registrationDocumentsReducer,
  serverSettingsReducer,
  experimentReducer,
  oauthReducer,
  userExperimentsReducer,
  agreementsReducer,
  loadersReducer,
};
